import { useAppVersion } from 'hooks/useAppVersion'
import { RefreshCw, X } from 'lucide-react'
import { useEffect, useState } from 'react'
import ButtonBase from './Button/ButtonBase'

/**
 * Componente que exibe notificação quando há uma nova versão disponível
 * Permite ao usuário recarregar a aplicação para obter a atualização
 */
export function UpdateNotification() {
    const { isUpdateAvailable, latestVersion, currentVersion, reloadApp } =
        useAppVersion()
    const [isVisible, setIsVisible] = useState(false)
    const [isDismissed, setIsDismissed] = useState(false)

    useEffect(() => {
        if (isUpdateAvailable && !isDismissed) {
            // Aguarda um pouco antes de mostrar a notificação
            const timer = setTimeout(() => {
                setIsVisible(true)
            }, 1000)

            return () => clearTimeout(timer)
        } else {
            setIsVisible(false)
        }
    }, [isUpdateAvailable, isDismissed])

    const handleDismiss = () => {
        setIsDismissed(true)
        setIsVisible(false)
    }

    const handleUpdate = () => {
        reloadApp()
    }

    if (!isVisible) {
        return null
    }

    return (
        <div className="fixed bottom-4 right-4 z-50 max-w-md animate-in slide-in-from-bottom-5">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 p-4">
                <div className="flex items-start gap-3">
                    <div className="flex-shrink-0">
                        <div className="w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900 flex items-center justify-center">
                            <RefreshCw className="w-5 h-5 text-blue-600 dark:text-blue-400" />
                        </div>
                    </div>

                    <div className="flex-1 min-w-0">
                        <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-100">
                            Nova versão disponível!
                        </h3>
                        <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
                            Uma atualização está disponível. Recarregue a página
                            para obter a versão mais recente.
                        </p>
                        <div className="mt-2 text-xs text-gray-500 dark:text-gray-500">
                            {currentVersion} → {latestVersion}
                        </div>

                        <div className="mt-3 flex gap-2">
                            <ButtonBase
                                onClick={handleUpdate}
                                variant="default"
                            >
                                Atualizar agora
                            </ButtonBase>
                            <ButtonBase
                                onClick={handleDismiss}
                                variant="secondary"
                            >
                                Depois
                            </ButtonBase>
                        </div>
                    </div>

                    <ButtonBase
                        onClick={handleDismiss}
                        className="flex-shrink-0 rounded-md p-1"
                        aria-label="Fechar notificação"
                        variant="outline"
                    >
                        <X className="w-5 h-5" />
                    </ButtonBase>
                </div>
            </div>
        </div>
    )
}
